import { Divider, Grid, Stack, styled } from '@mui/material'
import React from 'react'
import { AttentionLabel } from '../components/common/attentionLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ButtonOutlinedWarningS } from '../components/common/buttons/buttonOutlinedWarningS'
import { ButtonS } from '../components/common/buttons/buttonS'
import { GItem, GItemContainer, MiddleGItem } from '../components/common/grids'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { Form } from '../components/common/inputs/form'
import { TextBox } from '../components/common/inputs/textBox'
import { SubTitle } from '../components/common/subTitle'
import { yesNo } from '../../containers/common/constant/classification'
import { useAction } from '../../containers/memberModifyChildDiseaseTest/memberModifyChildDiseaseTestService'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { translate } from '../../i18n'
import { DatePicker } from '../components/common/inputs/datePicker'
import { RadioButtonGroup } from '../components/common/inputs/radioButtonGroup'


export const MemberModifyChildDiseaseTest = () => {
  const {
    CATEGORY_KEY,
    SUB_CATEGORIES,
    formMethods,
    fields,
    diseaseTests,
    categoryMst,
    onFieldAppend,
    onFieldRemove,
    onSubmit,
    childrenResultCode,
  } = useAction()

  let targetCategory: GetCategoryMstDto | undefined
  if (categoryMst) {
    targetCategory = categoryMst.find((mst) => mst.category === CATEGORY_KEY)
  }
  if (!targetCategory) return (<BackButton />)
  
  const diseaseTestCategory = categoryMst?.find((value) => value.category === CATEGORY_KEY)
  const subCategories = categoryMst?.filter((mst) => SUB_CATEGORIES.includes(mst.category))
  
  if (!diseaseTestCategory || !subCategories || subCategories.length === 0) return (<BackButton />)
  
  const subCategoryMap: {[key:string]: GetCategoryMstDto} = {}
  subCategories?.forEach(e => subCategoryMap[e.category.substring(CATEGORY_KEY.length + 1)] = e)
  const {testDate ,testResult} = subCategoryMap
  const labelData = testResult?.options?.map(op => ({ label: op.optionName, value: op.code })) ?? []
  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid container item xs={12} md={6} rowSpacing={1}>
            <Grid item xs={12}>
              <SubTitle title={diseaseTestCategory.name} />
            </Grid>
            <Grid item xs={0.3}/>
            <Grid item xs={11.7}>
            { diseaseTestCategory?.options && 
              diseaseTestCategory.options.map((opt, index) => {
  
                      return (
                       <>
                          <MiddleGItem xs={5} sm={2}>{opt.optionName}</MiddleGItem>
                          
                          {testDate != null && <GItemContainer xs={12} rowSpacing={1}>
                            <MiddleGItem xs={5} sm={2}>
                              <GItemContainer xs={12}>
                                <GItem xs={12}>
                                  <div>
                                    {testDate.required === yesNo.yes && (
                                      <AttentionLabel>*</AttentionLabel>
                                    )}
                                    {testDate.name}
                                  </div>
                                </GItem>
                              </GItemContainer>
                            </MiddleGItem>
                            <GItem xs={7} sm={10}>
                             <DatePicker 
                               name={`${CATEGORY_KEY}.${index}.testDate`}
                               label={testDate.name} 
                               required= {testDate.required === yesNo.yes}
                             />
                            </GItem>
                          </GItemContainer>}
                          {testResult?.options != null && testResult.options.length !== 0 && <GItemContainer xs={12} rowSpacing={1}>
                            <MiddleGItem xs={5} sm={2}>
                              <GItemContainer xs={12}>
                                <GItem xs={12}>
                                  <div>
                                    {testResult.required === yesNo.yes && (
                                      <AttentionLabel>*</AttentionLabel>
                                    )}
                                    {testResult.name}
                                  </div>
                                </GItem>
                              </GItemContainer>
                            </MiddleGItem>
                            <GItem xs={7} sm={10}>
                              <RadioButtonGroup
                                label={testResult.name}
                                name={`${CATEGORY_KEY}.${index}.testResult`}
                                buttonValueLabels={labelData}
                                required={testResult.required === yesNo.yes}
                                row
                              />
                            </GItem>
                          </GItemContainer>}
                          
                          {<AdmissionDivider />}
                        </>
                      )
              })
            }
            {
              fields != null && fields.map((e, i) => {
                if (diseaseTests != null && diseaseTests[i] != null && diseaseTests[i]?.deleted || (diseaseTestCategory?.options != null && i < diseaseTestCategory?.options?.length)) return null
                return (<InputForm key={e.id} subCategoryMap={subCategoryMap} topName={`${CATEGORY_KEY}.${i}`} onRemove={() => onFieldRemove(i)} />)
              })
            }
            <ButtonS onClick={onFieldAppend}>
              追加
            </ButtonS>
            </Grid>
          </Grid>
          <Grid item md={3}></Grid>
        </Grid>

        {!!childrenResultCode && (
          <ErrorMessageCard
            messages={[translate(`memberModifyChildDiseaseTest.error.childrenResultCode${childrenResultCode}`)]}
          />
        )}

        <BottomButtonGroup>
          <ButtonL fullWidth type="submit">
            {translate('memberModifyChildDiseaseTest.button.decision')}
          </ButtonL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}

interface InputFormProps {
  subCategoryMap: {[key:string]: GetCategoryMstDto}
  topName: string
  onRemove: () => void
}


const AdmissionDivider = styled(Divider)(() => ({
  marginBottom: "8px",
  marginTop: "8px",
}))

/** 各項目の入力フォーム */
const InputForm = (props: InputFormProps) => {
  const {subCategoryMap, topName, onRemove } = props
  const {testName, testDate, testResult} = subCategoryMap
  const labelData = testResult?.options?.map(op => ({ label: op.optionName, value: op.code })) ?? []
  const render = () => {
    return (
      <>
        {testName != null && <GItemContainer xs={12} rowSpacing={1}>
          <MiddleGItem xs={5} sm={2}>
            <GItemContainer xs={12}>
              <GItem xs={12}>
                <div>
                  {testName.required === yesNo.yes && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {testName.name}
                </div>
              </GItem>
            </GItemContainer>
          </MiddleGItem>
          <GItem xs={7} sm={10}>
            <TextBox
              label={testName.name}
              name={`${topName}.testName`}
              maxLength={testName.maxLength ?? 200}
              required={testName.required === yesNo.yes}
            />
          </GItem>
        </GItemContainer>}
        
        {testDate != null && <GItemContainer xs={12} rowSpacing={1}>
          <MiddleGItem xs={5} sm={2}>
            <GItemContainer xs={12}>
              <GItem xs={12}>
                <div>
                  {testDate.required === yesNo.yes && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {testDate.name}
                </div>
              </GItem>
            </GItemContainer>
          </MiddleGItem>
          <GItem xs={7} sm={10}>
           <DatePicker 
             name={`${topName}.testDate`}
             label={testDate.name} 
             required={testDate.required === yesNo.yes}
           />
          </GItem>
        </GItemContainer>}
        
        {testResult?.options != null && testResult.options.length !== 0 && <GItemContainer xs={12} rowSpacing={1}>
          <MiddleGItem xs={5} sm={2}>
            <GItemContainer xs={12}>
              <GItem xs={12}>
                <div>
                  {testResult.required === yesNo.yes && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {testResult.name}
                </div>
              </GItem>
            </GItemContainer>
          </MiddleGItem>
          <GItem xs={7} sm={10}>
            <RadioButtonGroup
              label={testResult.name}
              name={`${topName}.testResult`}
              buttonValueLabels={labelData}
              required={testResult.required === yesNo.yes}
              row
            />
          </GItem>
        </GItemContainer>}
        
        <ButtonOutlinedWarningS onClick={onRemove}>
          削除
        </ButtonOutlinedWarningS>
        {<AdmissionDivider />}
      </>
    )
  }
  
  return (render())
}